import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CompareProvider } from "@/context/CompareContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Explorer from "@/pages/Explorer";
import ProjectDetail from "@/pages/ProjectDetail";
import Compare from "@/pages/Compare";
import MarketGaps from "@/pages/MarketGaps";
import DesignMyICO from "@/pages/DesignMyICO";
import Assistant from "@/pages/Assistant";
import Sources from "@/pages/Sources";
import Jurisdictions from "@/pages/Jurisdictions";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CompareProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/explorer" element={<Explorer />} />
                <Route path="/project/:id" element={<ProjectDetail />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/opportunities" element={<MarketGaps />} />
                <Route path="/design" element={<DesignMyICO />} />
                <Route path="/assistant" element={<Assistant />} />
                <Route path="/sources" element={<Sources />} />
                <Route path="/jurisdictions" element={<Jurisdictions />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CompareProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
